import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RegisterPage from "./pages/RegisterPage";
import MentionsLegales from "./pages/MentionsLegales";
import Politique from "./pages/Politique";
import AppLayout from "./pages/AppLayout";
import Contact from "./pages/Contact";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import CommandesPage from "./pages/commandes/CommandesPage";
import Commandes from "./pages/Commandes";
import NouvelleFacture from "./pages/FacturesPage";
import MonComptePage from "./pages/MonComptePage";
import Devis from "./pages/Devis";
import Contrat from "./pages/Contrat";
import Prolongations from "./pages/Prolongations";
import Utilisateurs from "./pages/Utilisateurs";
import ReleveHeuresPage from "./pages/ReleveHeures/RelevesHeuresListe";
import Documents from "./pages/Documents";
import Candidat from "./pages/candidats/Candidat";
import CandidatModal from "./pages/candidats/CreateCandidateModal";
import Annonces from "./pages/Annonce";
import AideEnLigne from "./pages/AideEnLigne";
import RelevesHeures from "./pages/ReleveHeures/RelevesHeures";
import Planning from "./pages/Planning";
import FicheClientForm from "./pages/FicheClientForm";

function App() {
  return (
    <Routes>
      <Route path="/fiche-client/:token" element={<FicheClientForm />} />
      <Route path="/contact" element={<Contact />} />

      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/:token" element={<LoginPage />} />
      <Route path="/RegisterPage" element={<RegisterPage />} />

      <Route path="/mentions" element={<MentionsLegales />} />

      <Route path="/politique" element={<Politique />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      <Route path="" element={<AppLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/annonces" element={<Annonces />} />
        <Route path="/commandes" element={<Commandes />} />
        <Route path="/facture" element={<NouvelleFacture />} />
        <Route path="/compte" element={<MonComptePage />} />
        <Route path="/devis" element={<Devis />} />
        <Route path="/contrat" element={<Contrat />} />
        <Route path="/prolongations" element={<Prolongations />} />
        <Route path="/utilisateur" element={<Utilisateurs />} />
        <Route path="/relevesdheures" element={<ReleveHeuresPage />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/candidat" element={<Candidat />} />
        <Route path="/candidatModal" element={<CandidatModal />} />
        <Route path="/aide" element={<AideEnLigne />} />
        <Route path="/RelevesHeures" element={<RelevesHeures />} />
        <Route path="/planning" element={<Planning />} />
      </Route>
    </Routes>
  );
}

export default App;
